import { render, staticRenderFns } from "./PlpViewOptions.vue?vue&type=template&id=73bb4270&"
import script from "./PlpViewOptions.vue?vue&type=script&lang=js&"
export * from "./PlpViewOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports